/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_ErrorInputs */

const en_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send feedback. Please try again.`)
};

const de_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback konnte nicht gesendet werden. Bitte versuchen Sie es erneut.`)
};

const fr_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'envoi. Veuillez réessayer.`)
};

const es_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron enviar los comentarios. Inténtelo de nuevo.`)
};

const it_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio del feedback non riuscito. Riprova.`)
};

const nl_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback verzenden mislukt. Probeer het opnieuw.`)
};

const pl_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wysłać opinii. Spróbuj ponownie.`)
};

const fi_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palautteen lähettäminen epäonnistui. Yritä uudelleen.`)
};

const da_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke sende feedback. Prøv venligst igen.`)
};

const sv_feedback_error = /** @type {(inputs: Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det gick inte att skicka feedback. Försök igen.`)
};

/**
* | output |
* | --- |
* | "Failed to send feedback. Please try again." |
*
* @param {Feedback_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_error = /** @type {((inputs?: Feedback_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_error(inputs)
	if (locale === "fr") return fr_feedback_error(inputs)
	if (locale === "es") return es_feedback_error(inputs)
	if (locale === "it") return it_feedback_error(inputs)
	if (locale === "nl") return nl_feedback_error(inputs)
	if (locale === "pl") return pl_feedback_error(inputs)
	if (locale === "fi") return fi_feedback_error(inputs)
	if (locale === "da") return da_feedback_error(inputs)
	if (locale === "sv") return sv_feedback_error(inputs)
	return en_feedback_error(inputs)
});